import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { useState } from 'react';
import { createDeferredLoadable } from '../../../utils/createDeferredLoadable';
import { HubSpotCreditsWithTooltip } from './HubSpotCreditsWithTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoadableContactsModal = createDeferredLoadable(() => import( /* webpackChunkName: "public-contacts-price-breakdown-modal" */'../contacts-breakdown/PublicContactsPriceBreakdownModal'));
const HIDDEN_FROM_CREDITS = new Set(['CORE_SEAT', 'SALES_SEAT', 'SERVICE_SEAT', 'COMMERCE_SEAT', 'CUSTOM_EVENTS', 'CONTACTS']);
function findContactsQuantityPack(card) {
  var _qp$includedWithQuant, _qp$packagedQuantitie;
  const qp = card.quantityPacks.find(p => p.quantityName === 'CONTACTS');
  if (!qp || !qp.includedWithParentProduct) return undefined;
  return {
    skuUuid: qp.skuUuid,
    quantityName: 'CONTACTS',
    includedWithParentProduct: qp.includedWithParentProduct,
    includedWithQuantityPack: (_qp$includedWithQuant = qp.includedWithQuantityPack) !== null && _qp$includedWithQuant !== void 0 ? _qp$includedWithQuant : 0,
    packagedQuantitiesMap: (_qp$packagedQuantitie = qp.packagedQuantitiesMap) !== null && _qp$packagedQuantitie !== void 0 ? _qp$packagedQuantitie : {}
  };
}
export const PublicMerchCardCredits = ({
  card,
  commitmentTerm,
  paymentTerm,
  showMarketingContactsModal = false
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const contactsQP = showMarketingContactsModal ? findContactsQuantityPack(card) : undefined;
  const entries = Object.entries(card.packagedQuantitiesMap).filter(([name]) => !HIDDEN_FROM_CREDITS.has(name));
  const hasContacts = contactsQP && card.packagedQuantitiesMap['CONTACTS'];
  if (entries.length === 0 && !hasContacts) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [entries.map(([name, qty]) => {
      if (name === 'HUBSPOT_CREDITS') {
        return /*#__PURE__*/_jsx(HubSpotCreditsWithTooltip, {
          count: qty
        }, name);
      }
      return /*#__PURE__*/_jsxs(Text, {
        typography: "body-100",
        children: [qty.toLocaleString(), " ", name]
      }, name);
    }), hasContacts && contactsQP && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Text, {
        typography: "body-100",
        children: [/*#__PURE__*/_jsx(FormattedNumber, {
          value: card.packagedQuantitiesMap['CONTACTS']
        }), ' ', /*#__PURE__*/_jsx(Link, {
          onClick: () => setIsModalOpen(true),
          onMouseEnter: () => void LoadableContactsModal.preload(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.merchCard.credits.marketingContactsLink"
          })
        })]
      }), isModalOpen && /*#__PURE__*/_jsx(LoadableContactsModal, {
        onClose: () => setIsModalOpen(false),
        quantityPack: contactsQP,
        productLevel: card.productLevel ? String(card.productLevel) : undefined,
        commitmentTerm: commitmentTerm,
        paymentTerm: paymentTerm
      })]
    })]
  });
};